import ajax from "./promise";

export const wrapper = function(url, moduleName) {
  // if (process.env.NODE_ENV == 'test') {
  // 	return `http://192.168.3.164:7300/mock/61712afa1baaf000215cb78e${moduleName}${url}`;
  // } else {
  // 	return moduleName + url;
  // }
  return moduleName + url;
};

// const BASE_URL='192.168.1.54:8007'
// export const wrapper = function(url, moduleName) {
// 	return moduleName + url;
// }

export const webModule = "/service-website";

//新闻页添加（2.0）

export const _get_news_v2 = (id) =>
  ajax(wrapper("/new_news/getNewsById?id=" + id, webModule), {}, "GET");
export const _news_page_v2 = (params) =>
  ajax(wrapper("/new_news/getNewsPage", webModule), params, "POST");

//报告页添加（2.0）

export const _get_report_v2 = (id) =>
  ajax(wrapper("/new_news/getReportById?id=" + id, webModule), {}, "GET");
export const _report_page_v2 = (params) =>
  ajax(wrapper("/new_news/getReportPage", webModule), params, "POST");

//移动端首页研究成果
export const _mobile_report_page = (params) =>
  ajax(wrapper("/new_news/getMobileReportPage", webModule), params, "POST");
//移动端首页轮播图
export const getSlideshowPageMobile = (params) =>
  ajax(wrapper("/new_news/getSlideshowPageMobile", webModule), params, "POST");

//移动端首页新闻

export const _getSlideshowPageWebsite = (params) =>//首页轮播图
  ajax(wrapper("/new_news/getSlideshowPageWebsite", webModule), params, "POST");


//新增定制化需求单（2.0）
export const _add_order_v2 = (params) =>
  ajax(wrapper("/new_news/addOrder", webModule), params, "POST");

//获取定制化类型
export const _get_type_v2 = () =>
  ajax(wrapper("/new_news/getOrderType", webModule), {}, "GET");

//获取交易所类型
export const _get_type_exchange_v2 = () =>
  ajax(wrapper("/new_news/getExchangeType", webModule), {}, "GET");

//新增交易所需求单（2.0）
export const _add_exchange_v2 = (params) =>
  ajax(wrapper("/new_news/addExchange", webModule), params, "POST");

//系统公告
export const getOneByPlatform = (params) =>
  ajax(wrapper("/sysAnnouncement/getOneByPlatform", webModule), params, "POST");

//类型下拉
export const requirement_types = (type, requireOrigin) =>
  ajax(
    wrapper(
      `/new_news/requirement/types?type=${type}&requireOrigin=${requireOrigin}`,
      webModule
    ),
    {},
    "GET"
  );
//提交定制化需求
export const requirement_submit = (params) =>
  ajax(wrapper("/new_news/requirement/submit", webModule), params, "POST");

//横幅公告
export const getBanner = (params) =>
  ajax("/service-insight/announcement/announcement_config", params, "GET");

export const insightModule = "/service-insight/";
//获取wxconfig
export const getWxConfig = (params) =>
    ajax(wrapper("wechat/getWxConfig", insightModule), params, "GET");

export const _get_videoLsit = (params) =>//获取视频列表
  ajax(wrapper("/news_video/list", webModule), params, "POST");


//根据id获取专题
export const getSubject = (params) =>
    ajax(wrapper("/newSubject/getSubject", webModule), params, "GET");
//根据id获取专题详情
export const findDetailBySubjectId = (params) =>
    ajax(wrapper("/newSubject/findDetailBySubjectId", webModule), params, "GET");
//获取往期专题
export const findSubjectType = (params) =>
    ajax(wrapper("/newSubject/findSubjectType", webModule), params, "GET");

//专题banner分页查询
export const searchNewBanner = (params) =>
    ajax(wrapper("/newBanner/searchPage", webModule), params, "POST");